import Vue from 'vue'
import Router from 'vue-router'

const DefaultContainer = () => import('@/containers/DefaultContainer')

const Dashboard = () => import('@/views/Dashboard')
const Dashboards = () => import('@/views/Dashboards')
const PrintDashboard = () => import('@/views/pages/PrintDashboard')
const PrintWidget = () => import('@/views/pages/PrintWidget')

const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const Clients = () => import('@/views/pages/Clients')
const Client = () => import('@/views/pages/Client')
const ClientGroups = () => import('@/views/pages/ClientGroups')
const SwitchUser = () => import('@/views/pages/SwitchUser')
const ImportData = () => import('@/views/pages/ImportData')

const Reports = () => import('@/views/reports/Reports')

const Metrics = () => import('@/views/metrics/Metrics')
const Metric = () => import('@/views/metrics/Metric')



Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: '/dashboards',
          name: 'Dashboards',
          component: Dashboards
        },
        {
          path: '/dashboards/:id',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/clients',
          name: 'Clients',
          component: Clients
        },
        {
          path: '/clients/:id',
          name: 'Client',
          component: Client
        },
        {
          path: '/client_groups',
          name: 'Client Groups',
          component: ClientGroups
        },
        {
          path: '/import_data',
          name: 'Import Data',
          component: ImportData,
          meta: { requiresAdmin: true }
        },
        {
          path: '/switch_user',
          name: 'Switch User',
          component: SwitchUser
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
          ]
        },
        {
          path: '/metrics',
          name: 'Metrics',
          component: Metrics
        },
        {
          path: '/metrics/:id',
          name: 'Metric',
          component: Metric
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports
        }
      ]
    },
    {
      path: '/print_dashboard/:id',
      name: 'PrintDashboard',
      component: PrintDashboard
    },
    {
      path: '/print_widget/:id',
      name: 'PrintWidget',
      component: PrintWidget
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})
